import React from 'react';
import { Link } from 'react-router-dom';
import style from '../css/About.module.css';
import image from '../images/tech.png';
import Seven from '../components/Seven';
import Five from '../components/Five';
import Four from '../components/Four';
import Footer from '../components/Footer';
import Six from '../components/Six';
import Contact_Form from '../components/Contact_Form';

function About() {
	return (
		<div className={style.container}>
			{/* top section */}
			<div className={style.headerBack}>
				<div className={style.btnRow}>
					<Link className={style.btn} to={'/'}>
						Home
					</Link>
					<p>|</p>
					<Link className={style.btn} to={'/about-us'}>
						About
					</Link>
				</div>

				<div className={style.btnRow}>
					<Link className={style.btn} to={'/privacy-policy'}>
						Privacy & Policy
					</Link>
					<p>|</p>
					<Link className={style.btn} to={'/terms-and-conditions'}>
						Terms & Conditions
					</Link>
				</div>

				<h1>About Us</h1>
			</div>

			<Four />
			<Seven />
			<Five />
			<Contact_Form />
			<Six />

			<Footer />
		</div>
	);
}

export default About;
